import {
  TimeZoneSmIcon,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@crono-one/design-system';

const CONTACT_LOCAL_TIME_LABEL = 'Contact local time enabled';

interface ContactLocalTimeIndicatorProps {
  className?: string;
}

/**
 * Read-only marker on a step whose sequence schedules in the contact's timezone.
 * The setting itself lives on the sequence, edited from the Sequence timezone modal.
 */
const ContactLocalTimeIndicator = ({
  className,
}: ContactLocalTimeIndicatorProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span
        role="img"
        aria-label={CONTACT_LOCAL_TIME_LABEL}
        className={`flex size-6 items-center justify-center text-gray-700 ${className ?? ''}`}
      >
        <TimeZoneSmIcon />
      </span>
    </TooltipTrigger>
    <TooltipContent>{CONTACT_LOCAL_TIME_LABEL}</TooltipContent>
  </Tooltip>
);

export default ContactLocalTimeIndicator;
